import React from 'react';
import styled from 'styled-components';
import { EntityRole } from '../../utils/apollo/graphqlSchema';
import { entityRolesLabels } from '../../utils/entityRoles';
import { theme } from '../../styles/theme';
import { SquareRemoveButton } from '../Button';
import BuilderSelectMenu from '../Builder/BuilderSelectMenu';

interface IProps {
  entityRole: EntityRole;
  options: EntityRole[];
  onChange: (entityRole: EntityRole) => void;
  onRemove?: () => void;
  disabled?: boolean;
}

const Container = styled.div<{ $isOwner?: boolean }>`
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: ${({ $isOwner }) =>
    $isOwner ? 'auto 16px 24px' : 'auto 24px'};
  justify-content: end;
`;
const Label = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.mainBlue};
`;
const DisabledLabel = styled(Label)`
  margin-right: 16px;
`;

const EntityPermissionsWidgetRoles = ({
  entityRole,
  options,
  onChange,
  onRemove,
  disabled,
}: IProps) => {
  if (entityRole === EntityRole.Owner) {
    return (
      <Container $isOwner={true}>
        <Label>{entityRolesLabels[entityRole]}</Label>
      </Container>
    );
  }

  // If there's only one option or disabled is true, show it as text instead of a dropdown
  if (options.length === 1 || disabled) {
    return (
      <Container>
        <DisabledLabel>{entityRolesLabels[entityRole]}</DisabledLabel>
        {onRemove && (
          <SquareRemoveButton onClick={onRemove} content={'Remove User'} />
        )}
      </Container>
    );
  }

  const handleChange = (newValue: string) => {
    onChange(newValue as EntityRole);
  };

  return (
    <Container>
      <BuilderSelectMenu
        value={entityRole}
        options={options.map((role) => ({
          text: entityRolesLabels[role],
          value: role,
        }))}
        onChange={handleChange}
        strategy="fixed"
        placement="bottom-end"
      />
      {onRemove && (
        <SquareRemoveButton onClick={onRemove} content={'Remove User'} />
      )}
    </Container>
  );
};

export default EntityPermissionsWidgetRoles;
